import React from 'react';

export interface FilterContextProps {
  dates: { startDate: number, endDate: Date }
  filterType: string
  setDates: Function
  setFilterType: Function
}

const TransactionContext = React.createContext<Partial<FilterContextProps>>({
  dates: { startDate: 0, endDate: new Date() },
  filterType: '',
  setFilterType: () => {},
  setDates: () => {}
});

export default TransactionContext;
